<template>
  <v-toolbar
    data-js="get-height"
    class="action-bar"
    :class="{ 'action-bar--ml': !hasMainMenuOpen }"
    flat
  >
    <Breadcrumb :routes="breadcrumbItems" />
    <v-spacer />
    <slot></slot>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import { hasRole } from 'utils/functions'
import Breadcrumb from 'components/Breadcrumb'

export default {
  name: 'ActionBar',
  props: {
    breadcrumbItems: {
      type: Array
    }
  },
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState({
      hasMainMenuOpen: ({ mainMenu }) => mainMenu.isOpen
    })
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>

<style lang="scss">
.action-bar {
  box-shadow: 0 0 0 1px var(--gray-3) !important;
  left: 0;
  overflow: auto;
  position: absolute;
  right: 0;
  top: 113px;
  white-space: nowrap;
  z-index: 2;

  @media (min-width: 961px) {
    left: $menu-width;
    position: fixed;
    top: $toolbar-height;
  }

  .v-toolbar__content {
    padding-right: 0;
  }
}

.action-bar--ml {
  left: 0;

  @media (min-width: 961px) {
    left: $mini-menu-width;
  }
}

.actions-items {
  padding: 4px 10px;

  > div {
    align-items: center;
    display: flex;
  }

  .actions-items__item a {
    text-decoration: none;

    &:hover {
      text-decoration: none;

      span {
        text-decoration: underline;
      }
    }
  }

  .actions-items__item {
    margin-left: 16px;
  }
}
</style>
